import React, { useEffect, useState } from "react";
import { MdOutlineCancelPresentation, MdTimerOff } from "react-icons/md";
import { BiListCheck, BiListUl } from "react-icons/bi";
import {
  RiDashboardFill,
  RiCustomerService2Fill,
  RiEBike2Fill,
} from "react-icons/ri";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import { GoTriangleLeft, GoTriangleRight } from "react-icons/go";
import { GiScubaTanks, GiCancel } from "react-icons/gi";
import liteBig from "../../assets/images/big.png";
import liteSmall from "../../assets/images/small.png";
import style from "./Sidenav.module.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaClinicMedical, FaMedkit } from "react-icons/fa";
import { TbTruckReturn, TbDropletPause } from "react-icons/tb";
import { VscDebugStepOver } from "react-icons/vsc";

const Sidenav = ({ onClickYes, cylinderId }) => {
  const [currentLink, setCurrentLink] = useState();
  const [sideNav, setSideNav] = useState(false);
  const [cylinderTab, setcylinderTab] = useState(false);
  const [notifyNerveTab, setNotifyNerveTab] = useState(false);
  const [declineTab, setDeclineTab] = useState(false);
  const [hospitalTab, setHospitalTab] = useState(false);

  const { pathname } = useLocation();

  const navigate = useNavigate();

  const cylinderFunc = () => {
    setcylinderTab(!cylinderTab);
    setCurrentLink(12);
  };

  const declineFunc = () => {
    setDeclineTab(!declineTab);
    setCurrentLink(21);
  };

  const hospitalFunc = () => {
    setHospitalTab(!hospitalTab);
    setCurrentLink(8);
  };

  const notifyNerveFunc = () => {
    setNotifyNerveTab(!notifyNerveTab);
    setCurrentLink(17);
    // setCurrentLink(17)
  };

  useEffect(() => {
    if (pathname === "") {
      setCurrentLink(1);
    } else if (pathname === `/new-orders`) {
      setCurrentLink(3);
    } else if (pathname === `/ongoing`) {
      setCurrentLink(3);
    } else if (pathname === `/completed`) {
      setCurrentLink(10);
    } else if (pathname === `/overdue`) {
      setCurrentLink(11);
    } else if (pathname === `/cylinders`) {
      setCurrentLink(12);
    } else if (pathname === `/cancelled`) {
      setCurrentLink(2);
    } else if (pathname === `/tickets`) {
      setCurrentLink(4);
    } else if (pathname === "/inventory-upload") {
      setCurrentLink(5);
    } else if (pathname === `/user`) {
      setCurrentLink(7);
    } else if (pathname === `/notifications`) {
      setCurrentLink(13);
    } else if (pathname === `/hospitals`) {
      setCurrentLink(8);
    } else if (pathname === `/vendors`) {
      setCurrentLink(9);
    } else if (pathname === `/riders`) {
      setCurrentLink(6);
    } else if (pathname === "/nerve-claims") {
      setCurrentLink(14);
    } else if (pathname === "/crade/request") {
      setCurrentLink(15);
    } else if (pathname === "/incident/report") {
      setCurrentLink(16);
    } else if (pathname === "/notify/nerve/") {
      setCurrentLink(17);
    } else if (pathname === "/create-cohort") {
      setCurrentLink(18);
    } else if (pathname === "/purchase-order") {
      setCurrentLink(19);
    } else if (pathname === "/see-quotation") {
      setCurrentLink(20);
    } else if (pathname === "/ova") {
      setCurrentLink(21);
    } else if (pathname === `/returns`) {
      setCurrentLink(22);
    } else if (pathname === `/return-list`) {
      setCurrentLink(23);
    } else if (pathname === `/override`) {
      setCurrentLink(24);
    }
  }, [pathname]);

  const handleMouseOver = () => {
    setSideNav(true);
  };

  const handleMouseOut = () => {
    setSideNav(false);
  };

  return (
    <>
      {sideNav && (
        <div
          className={style.flexContainer1}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          <div className={style.logo}>
            <img className="lite me-3 ms-3" src={liteBig} alt="lifebank" />
            <GoTriangleLeft
              size={25}
              color="white"
              style={{ cursor: "pointer" }}
              onClick={() => setSideNav(!sideNav)}
            />
          </div>
          <div className={style.top}>
            <div>
              <div
                className={currentLink === 1 ? style.active : style.menu}
                onClick={() => setCurrentLink(1)}
              >
                <Link className={style.link} to={`/`}>
                  <RiDashboardFill size={25} className={style.icon} />
                  <p> Dashboard</p>
                </Link>
              </div>

              <div
                className={currentLink === 2 ? style.active : style.menu}
                onClick={() => setCurrentLink(2)}
              >
                <Link className={style.link} to={`/cancelled`}>
                  <MdOutlineCancelPresentation
                    size={25}
                    className={style.icon}
                  />

                  <p>Cancelled Orders</p>
                </Link>
              </div>
              <div
                className={currentLink === 3 ? style.active : style.menu}
                onClick={() => setCurrentLink(3)}
              >
                <Link className={style.link} to={`/ongoing`}>
                  <BiListUl size={25} className={style.icon} />

                  <p> Ongoing Orders</p>
                </Link>
              </div>
              <div
                className={currentLink === 10 ? style.active : style.menu}
                onClick={() => setCurrentLink(10)}
              >
                <Link className={style.link} to={`/completed`}>
                  <BiListCheck size={25} className={style.icon} />

                  <p> Completed Orders</p>
                </Link>
              </div>
              <div
                className={currentLink === 24 ? style.active : style.menu}
                onClick={() => setCurrentLink(24)}
              >
                <Link className={style.link} to={`/override`}>
                  <VscDebugStepOver size={25} className={style.icon} />

                  <p> Override Orders</p>
                </Link>
              </div>
              <div
                className={currentLink === 11 ? style.active : style.menu}
                onClick={() => setCurrentLink(11)}
              >
                <Link className={style.link} to={`/overdue`}>
                  <MdTimerOff size={25} className={style.icon} />

                  <p> Overdue Orders</p>
                </Link>
              </div>
              <div
                className={currentLink === 4 ? style.active : style.menu}
                onClick={() => setCurrentLink(4)}
              >
                <Link className={style.link} to={`/tickets`}>
                  <RiCustomerService2Fill size={25} className={style.icon} />

                  <p>Tickets</p>
                </Link>
              </div>
              <div
                className={currentLink === 22 ? style.active : style.menu}
                onClick={() => setCurrentLink(22)}
              >
                <Link className={style.link} to={`/returns`}>
                  <TbTruckReturn size={25} className={style.icon} />

                  <p>Returns</p>
                </Link>
              </div>
              <div
                className={currentLink === 23 ? style.active : style.menu}
                onClick={() => setCurrentLink(23)}
              >
                <Link className={style.link} to={`/return-list`}>
                  <TbDropletPause size={25} className={style.icon} />

                  <p>Ongoing Returns</p>
                </Link>
              </div>
              <div
                className={currentLink === 12 ? style.active : style.menu}
                onClick={() => notifyNerveFunc()}
              >
                <div className={style.tabLink}>
                  <div className={`${style.sidebarLinks}`}>
                    <p>
                      <RiCustomerService2Fill
                        size={25}
                        className={style.icon}
                      />
                    </p>
                    <Link className={style.tabLink} to={`/notify/nerve/`}>
                      Notify Nerve
                    </Link>
                    <p>
                      {notifyNerveTab ? (
                        <MdKeyboardArrowUp
                          onClick={() => navigate("/notify/nerve/")}
                          size={20}
                        />
                      ) : (
                        <MdKeyboardArrowDown
                          onClick={() => navigate("/notify/nerve/")}
                          size={20}
                        />
                      )}
                    </p>
                  </div>

                  {notifyNerveTab && (
                    <div className={style.tabAreas}>
                      <div onClick={() => navigate(`/notify/nerve/`)}>
                        {/* <div onClick={() => onClickYes()}> */}
                        <p className={`pt-3 ${style.tabAreasInner}`}>
                          Single message
                        </p>
                      </div>
                      <div onClick={() => navigate(`/cohort-message`)}>
                        <p className={`pt-2 pl-3 ${style.tabAreasInner}`}>
                          Cohort message
                        </p>
                      </div>
                      <div onClick={() => navigate(`/create-cohort`)}>
                        <p className={`pt-3 ${style.tabAreasInner}`}>
                          Create Cohort
                        </p>
                      </div>
                      <div>
                        {/* <p className={`pt-3 ${style.tabAreasInner}`}>
                          Edit Cohort
                        </p> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div
                className={currentLink === 6 ? style.active : style.menu}
                onClick={() => setCurrentLink(6)}
              >
                <Link className={style.link} to={`/riders`}>
                  <RiEBike2Fill size={25} className={style.icon} />
                  <p> Dispatch</p>
                </Link>
              </div>

              <div
                className={currentLink === 16 ? style.active : style.menu}
                onClick={() => setCurrentLink(16)}
              >
                <Link className={style.link} to={`/incident/report`}>
                  <GiScubaTanks size={25} className={style.icon} />
                  <p>Incident Report</p>
                </Link>
              </div>

              <div
                className={currentLink === 21 ? style.active : style.menu}
                onClick={() => declineFunc()}
              >
                <div className={style.tabLink}>
                  <div className={`${style.sidebarLinks}`}>
                    <p>
                      <GiCancel size={25} className={style.icon} />
                    </p>
                    <Link className={style.tabLink}>Failed Order</Link>
                    <p>
                      {declineTab ? (
                        <MdKeyboardArrowUp
                          // onClick={() => navigate("/ova")}
                          size={20}
                        />
                      ) : (
                        <MdKeyboardArrowDown
                          // onClick={() => navigate("/ova")}
                          size={20}
                        />
                      )}
                    </p>
                  </div>

                  {declineTab && (
                    <div className={style.tabAreas}>
                      <div onClick={() => navigate(`/ova`)}>
                        {/* <div onClick={() => onClickYes()}> */}
                        <p className={`pt-3 ${style.tabAreasInner}`}>
                          Vendor Declined Orders
                        </p>
                      </div>
                      <div onClick={() => navigate(`/pricing`)}>
                        <p className={`pt-2 pl-3 ${style.tabAreasInner}`}>
                          Pricing Error
                        </p>
                      </div>
                      <div onClick={() => navigate(`/failed-bids`)}>
                        <p className={`pt-2 pl-3 ${style.tabAreasInner}`}>
                          Failed Bids
                        </p>
                      </div>

                      <div onClick={() => navigate(`/declined-quotation`)}>
                        <p className={`pt-2 pl-3 ${style.tabAreasInner}`}>
                          Declined Quotations
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div
                className={currentLink === 7 ? style.active : style.menu}
                onClick={() => setCurrentLink(7)}
              >
                <Link className={style.link} to={`/user`}>
                  <FiUsers size={25} className={style.icon} />

                  <p> Users</p>
                </Link>
              </div>
              <div
                className={currentLink === 14 ? style.active : style.menu}
                onClick={() => setCurrentLink(14)}
              >
                <Link className={style.link} to={`/nerve-claims`}>
                  <FaMedkit size={25} className={style.icon} />
                  <p>Nerve Account Verify</p>
                </Link>
              </div>
              <div
                className={currentLink === 15 ? style.active : style.menu}
                onClick={() => setCurrentLink(15)}
              >
                <Link className={style.link} to={`/crade/request`}>
                  <FaMedkit size={25} className={style.icon} />
                  <p>Cadre Request</p>
                </Link>
              </div>

              <div
                className={currentLink === 8 ? style.active : style.menu}
                onClick={() => hospitalFunc()}
              >
                <div className={style.tabLink}>
                  <div className={`${style.sidebarLinks}`}>
                    <FaClinicMedical size={25} className={style.icon} />
                    <Link className={style.tabLink}>Hospitals</Link>
                    <p>
                      {hospitalTab ? (
                        <MdKeyboardArrowUp
                          // onClick={() => navigate("/ova")}
                          size={20}
                        />
                      ) : (
                        <MdKeyboardArrowDown
                          // onClick={() => navigate("/ova")}
                          size={20}
                        />
                      )}
                    </p>
                  </div>

                  {hospitalTab && (
                    <div className={style.tabAreas}>
                      <div onClick={() => navigate(`/lifebank-hospitals`)}>
                        {/* <div onClick={() => onClickYes()}> */}
                        <p className={`pt-3 ${style.tabAreasInner}`}>
                          LifeBank Hospitals
                        </p>
                      </div>

                      <div onClick={() => navigate(`/pipeline-hospitals`)}>
                        <p className={`pt-3 ${style.tabAreasInner}`}>
                          PipeLine Hospitals
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* <div
                className={currentLink === 9 ? style.active : style.menu}
                onClick={() => setCurrentLink(9)}
              >
                <Link className={style.link} to={`/vendors`}>
                  <FaBriefcaseMedical size={25} className={style.icon} />

                  <p>Vendors</p>
                </Link>
              </div> */}

              <div
                className={currentLink === 12 ? style.active : style.menu}
                onClick={() => cylinderFunc()}
              >
                <div className={style.tabLink}>
                  <div className={`${style.sidebarLinks}`}>
                    <p>
                      <GiScubaTanks size={25} className={style.icon} />
                    </p>
                    <Link className={style.tabLink} to={`/cylinders`}>
                      Cylinders
                    </Link>
                    <p>
                      {cylinderTab ? (
                        <MdKeyboardArrowUp
                          onClick={() => navigate("/cylinders")}
                          size={20}
                        />
                      ) : (
                        <MdKeyboardArrowDown
                          onClick={() => navigate("/cylinders")}
                          size={20}
                        />
                      )}
                    </p>
                  </div>

                  {cylinderTab && (
                    <div className={style.tabAreas}>
                      <div onClick={() => navigate(`/cylinders/hospitals`)}>
                        <p className={`pt-3 ${style.tabAreasInner}`}>
                          Hospitals With Cylinders
                        </p>
                      </div>
                      <div onClick={() => onClickYes()}>
                        <p className={`pt-3 ${style.tabAreasInner}`}>
                          New Cylinder
                        </p>
                      </div>
                      <div onClick={() => navigate(`/cylinders/batches`)}>
                        <p className={`pt-2 pl-3 ${style.tabAreasInner}`}>
                          Cylinder Batch
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* small size */}
      {!sideNav && (
        <div
          className={style.flexContainer}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
        >
          <div className={style.top}>
            <div>
              <div className={style.logo}>
                <img
                  className="lite me-2 ms-2"
                  src={liteSmall}
                  alt="lifebank"
                />
                <GoTriangleRight
                  size={20}
                  color="white"
                  onClick={() => setSideNav(!sideNav)}
                  style={{ cursor: "pointer" }}
                />
              </div>

              <div
                className={currentLink === 1 ? style.active : style.menu}
                onClick={() => setCurrentLink(1)}
              >
                <Link className={style.link} to={`/`}>
                  <RiDashboardFill size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 2 ? style.active : style.menu}
                onClick={() => setCurrentLink(2)}
              >
                <Link className={style.link} to={`/cancelled`}>
                  <MdOutlineCancelPresentation
                    size={25}
                    className={style.icon}
                  />
                </Link>
              </div>

              <div
                className={currentLink === 3 ? style.active : style.menu}
                onClick={() => setCurrentLink(3)}
              >
                <Link className={style.link} to={`/ongoing`}>
                  <BiListUl size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 10 ? style.active : style.menu}
                onClick={() => setCurrentLink(10)}
              >
                <Link className={style.link} to={`/completed`}>
                  <BiListCheck size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 24 ? style.active : style.menu}
                onClick={() => setCurrentLink(24)}
              >
                <Link className={style.link} to={`/override`}>
                  <VscDebugStepOver size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 11 ? style.active : style.menu}
                onClick={() => setCurrentLink(11)}
              >
                <Link className={style.link} to={`/overdue`}>
                  <MdTimerOff size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 4 ? style.active : style.menu}
                onClick={() => setCurrentLink(4)}
              >
                <Link className={style.link} to={`/tickets`}>
                  <RiCustomerService2Fill size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 22 ? style.active : style.menu}
                onClick={() => setCurrentLink(22)}
              >
                <Link className={style.link} to={`/returns`}>
                  <TbTruckReturn size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 23 ? style.active : style.menu}
                onClick={() => setCurrentLink(23)}
              >
                <Link className={style.link} to={`/return-list`}>
                  <TbDropletPause size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 6 ? style.active : style.menu}
                onClick={() => setCurrentLink(6)}
              >
                <Link className={style.link} to={`/riders`}>
                  <RiEBike2Fill size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 21 ? style.active : style.menu}
                onClick={() => setCurrentLink(21)}
              >
                <Link className={style.link} to="/ova">
                  <GiCancel size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 7 ? style.active : style.menu}
                onClick={() => setCurrentLink(7)}
              >
                <Link className={style.link} to={`/user`}>
                  <FiUsers size={25} className={style.icon} />
                </Link>
              </div>

              <div
                className={currentLink === 14 ? style.active : style.menu}
                onClick={() => setCurrentLink(14)}
              >
                <Link className={style.link} to={`/nerve-claims`}>
                  <FaMedkit size={25} className={style.icon} />
                </Link>
              </div>
              <div className={currentLink === 15 ? style.active : style.menu}>
                <Link className={style.link} to={`/crade/request`}>
                  <FaMedkit size={25} className={style.icon} />
                </Link>
              </div>

              {/* <div
                className={currentLink === 13 ? style.active : style.menu}
                onClick={() => setCurrentLink(7)}
              >
                <Link className={style.link} to={`/notifications`}>
                  <FiBell size={25} className={style.icon} />
                </Link>
              </div> */}

              <div
                className={currentLink === 8 ? style.active : style.menu}
                onClick={() => setCurrentLink(8)}
              >
                <Link className={style.link} to={`/hospitals`}>
                  <FaClinicMedical size={25} className={style.icon} />
                </Link>
              </div>

              {/* <div
                className={currentLink === 9 ? style.active : style.menu}
                onClick={() => setCurrentLink(9)}
              >
                <Link className={style.link} to={`/vendors`}>
                  <FaBriefcaseMedical size={25} className={style.icon} />
                </Link>
              </div> */}

              <div
                className={currentLink === 12 ? style.active : style.menu}
                onClick={() => setCurrentLink(12)}
              >
                <Link className={style.link} to={`/cylinders`}>
                  <GiScubaTanks size={25} className={style.icon} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidenav;
